export const styles = {
  display: "table",
  margin: "auto",
};
export const Iconstyle = {
  color: "white",
  position: "absolute",
  top: "10px",
  left: "175px",
  cursor: "pointer",
  fontSize: "18px",
  zIndex: 999,
};

export const IconstyleRed = {
  color: "#c02e26",
  position: "absolute",
  top: "10px",
  left: "175px",
  cursor: "pointer",
  fontSize: "18px",
  zIndex: 999,
};
